
import Vue from 'vue'
export default Vue.extend({
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    error: Boolean,
  },
  data() {
    return {
      value: '',
    }
  },
})
